/**
 * 27/10/2026 — each kind's rows that found their match by themselves, folded into one row per
 * kind: the count, and how they matched ("21 same name · 1 picked"); the rows that needed the
 * person sit in the status card instead ("2 above"), so no item has two pickers.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { ReviewFold } from '@/features/drop-generator/components/group-copy/dialog/blocks/ReviewFold';
import type { MatchKind } from '@/features/drop-generator/components/group-copy/dialog/model/paste-summary';

import type { PickEntry, PickKind } from './use-pick-kinds';

interface Props {
  kinds: PickKind[];
  /** In the status card — the rows that needed the person. */
  inCard: (kind: MatchKind, key: string) => boolean;
}

/** "21 same name · 1 picked · 2 above". */
export function foldSummary(rows: PickEntry[], total: number): string {
  const counts = new Map<string, number>();
  for (const r of rows) counts.set(r.badge.label, (counts.get(r.badge.label) ?? 0) + 1);
  const above = total - rows.length;
  return [...[...counts].map(([label, n]) => `${n} ${label}`), above ? `${above} above` : null].filter(Boolean).join(' · ');
}

export const PickFolds: FC<Props> = ({ kinds, inCard }) => (
  <>
    {kinds.map((k) => {
      const rows = k.entries.filter((e) => !inCard(k.kind, e.key));
      if (rows.length === 0) return null;
      return (
        <ReviewFold key={k.kind} icon={k.icon} title={k.title} count={k.entries.length} summary={foldSummary(rows, k.entries.length)}>
          <p className="px-5 py-2 text-[11.5px] text-muted-foreground">{k.legend}</p>
          {rows.map((e) => e.render(true))}
        </ReviewFold>
      );
    })}
  </>
);
